/**
 * Product Image Zoom with ViewerJS
 * Versão simplificada e otimizada
 */

(function() {
  'use strict';

  let attempts = 0;
  const maxAttempts = 10;

  function waitForDependencies() {
    attempts++;
    
    if (attempts > maxAttempts) {
      console.error('ViewerJS: Máximo de tentativas excedido');
      return;
    }

    // Verifica se ViewerJS está carregada e se a galeria existe
    if (typeof Viewer === 'undefined') {
      setTimeout(waitForDependencies, 500);
      return;
    }

    const gallery = document.getElementById('product-images-gallery');
    if (!gallery) {
      setTimeout(waitForDependencies, 500);
      return;
    }

    // Tudo pronto, inicializa
    initViewerJS(gallery);
  }

  function initViewerJS(gallery) {
    try {
      // Configuração mínima do ViewerJS
      const viewer = new Viewer(gallery, {
        inline: false,
        button: true,
        navbar: true,
        title: false,
        toolbar: {
          zoomIn: 1,
          zoomOut: 1,
          oneToOne: 1,
          reset: 1,
          prev: 1,
          play: { show: 1, size: 'large' },
          next: 1,
          close: {
            show: 1,
            click: function() {
              viewer.hide();
            }
          }
        },
        tooltip: true,
        movable: true,
        zoomable: true,
        rotatable: false,
        scalable: false,
        transition: true,
        fullscreen: true,
        keyboard: true,
        backdrop: true,
        loading: true,
        loop: true,
        url: 'data-original',
        zoomRatio: 0.1,
        minZoomRatio: 0.1,
        maxZoomRatio: 3
      });

      // Adiciona indicadores visuais simples
      const images = gallery.querySelectorAll('.product-zoom-image');
      images.forEach(img => {
        img.style.cursor = 'zoom-in';
        img.title = 'Clique para ampliar';
      });

      console.log('✅ ViewerJS inicializada com sucesso!');
      
    } catch (error) {
      console.error('❌ Erro ao inicializar ViewerJS:', error);
    }
  }

  // Inicia o processo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForDependencies);
  } else {
    waitForDependencies();
  }

})();
